import isEmpty from 'lodash/isEmpty';

import { doRequest } from '@r1-frontend/do-request';
import {
    changePlanWebcab,
    RequestDto as IChangeTariffPlanBodyDto,
} from '@r1-frontend/api-domru/api-profile/v1/change-tariff/change-plan-webcab';

import { setChangePlanWebcabData, setLoading, setStep } from '~/src/features/tariffBuilder/actions';
import { constructorCurrentTariffAnalytics } from '~/src/features/tariffBuilder/analytics';
import { TCtxDispatch } from '~/src/features/tariffBuilder/Ctx';
import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import getBaseTvItem from '~/src/features/tariffBuilder/selectors/getBaseTvItem';
import { hasSelectedEquipment } from '~/src/features/tariffBuilder/selectors/hasSelectedEquipment';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';
import { ESteps } from '~/src/features/tariffBuilder/types/ESteps';

const getVasKitServices = (state: TInitialState, services: number[]): number[] | undefined => {
    if (!isEmpty(state[EEntity.tv])) {
        const baseTvItem = getBaseTvItem(state);
        return [...new Set(services)].filter(item => item !== baseTvItem.id);
    }
    return services;
};

const changePlanWebcabThunk = (trId: number | null) => async(dispatch: TCtxDispatch, getState: () => TInitialState) => {
    const state = getState();

    const { planId, salePackageId, selectedEntityIds, client } = state;
    const { contactPhone, phone } = client;

    dispatch(setLoading(true));

    const hasEquipment = hasSelectedEquipment(state);

    const vasKitServices = getVasKitServices(state, selectedEntityIds.services);

    const requestBody: IChangeTariffPlanBodyDto = {
        trId: String(trId),
        // TODO - доработку на бэк, избавиться от параметра 0.
        nextMonth: 0,
        planId: Number(planId),
        isNeedRequest: false,
        promoId: Number(salePackageId),
        vasKitServices: vasKitServices,
        phoneNumber: phone ? phone : undefined,
        contactId: contactPhone?.isContactId ? Number(contactPhone.value) : undefined,
    };
    const response = await doRequest.apiProfile<string>(changePlanWebcab(requestBody));

    if (!response.isSuccess) {
        dispatch(setChangePlanWebcabData({ hasError: true, errorCode: response.error.code, errorMessage: response.error.message }));
        constructorCurrentTariffAnalytics.changeTariff.confirmTariffChangingError();
    }

    if (response.isSuccess) {
        dispatch(setChangePlanWebcabData({ data: response.payload }));
        if (!hasEquipment) {
            constructorCurrentTariffAnalytics.changeTariff.confirmTariffChangingSuccess();
        } else {
            constructorCurrentTariffAnalytics.changeTariff.confirmTariff100plusChangingSuccess();
        }
    }

    if (!hasEquipment) {
        dispatch(setStep(ESteps.Final));
    }

    dispatch(setLoading(false));
};

export default changePlanWebcabThunk;
